import { useMemo } from 'react';
import { ID } from 'shared/types/id';
import { getSubGoals } from 'shared/utils/get-sub-goals';

import { useGoals } from './use-goals';

export const useSubGoals = (id?: ID, recursive = false) => {
  const goals = useGoals();

  return useMemo(
    () => getSubGoals(id, { goals, recursive }),
    [goals, id, recursive],
  );
};
